import type { IconType } from "react-icons";
import {
    RiLeafLine,
    RiKnifeLine,
    RiRestaurantLine,
    RiDropLine,
    RiPriceTag3Line,
    RiCake2Line,
    RiSparklingLine,
    RiPaintBrushLine,
    RiCupLine,
    RiShoppingBasketLine,
    RiGobletLine,
    RiPlantLine,
} from "react-icons/ri";
import { GiMeat, GiNoodles, GiCheeseWedge } from "react-icons/gi";
import { TbMeat, TbBottle, TbDog } from "react-icons/tb";

/** Mapa de chave → ícone, compartilhado por qualquer feature (ver componente `Icon`). */
export const ICON_MAP: Record<string, IconType> = {
    leaf: RiLeafLine,
    knife: RiKnifeLine,
    meat: GiMeat,
    noodles: GiNoodles,
    drop: RiDropLine,
    tag: RiPriceTag3Line,
    cheese: GiCheeseWedge,
    cake: RiCake2Line,
    sparkling: RiSparklingLine,
    brush: RiPaintBrushLine,
    cup: RiCupLine,
    basket: RiShoppingBasketLine,
    wine: RiGobletLine,
    plant: RiPlantLine,
    restaurant: RiRestaurantLine,
    bottle: TbBottle,
    dog: TbDog,
    "meat-alt": TbMeat,
};


